import {
  CarDeckInventoryClass,
  DeckAvailability,
  InventoryClass,
  PassengerDeckInventoryClass,
} from '@/root/shared-types/selectDatePage/inventory-types'
import { InventoryValues } from './getInventoryValues'

/**
 * Reads the RESIDENT reserve nested inside a deck's inventory class.
 * Defaults to the passenger `DECK` class; pass `'CAR_DECK'` to read the resident car reserve.
 */
export const getResidentInventoryValues = <T extends PassengerDeckInventoryClass | CarDeckInventoryClass>(
  deckAvailability?: DeckAvailability<T>,
  inventoryClass: InventoryClass = 'DECK'
): InventoryValues => {
  if (!deckAvailability) {
    return {}
  }

  const deckItem = deckAvailability.availableInventoryClasses.find((item) => item.inventoryClass === inventoryClass)
  const residentReserve = deckItem?.reserves?.find((reserve) => reserve.reserveType === 'RESIDENT')

  return {
    amount: residentReserve?.amount,
    total: residentReserve?.total,
  }
}
